import React, { useState } from "react";
import {
  Fade,
  Box,
  Typography,
  Button,
  IconButton,
  Popover,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CloseIcon from "@mui/icons-material/Close";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";

export default function StepBox({
  currentStep,
  title,
  body,
  extra_content,
  onNext,
  onPrevious,
  onSkip,
  align = "center",
  totalSteps,
}) {
  const { t } = useTranslation("main");
  const isLastStep = totalSteps === currentStep + 1;
  const [showContent, setShowContent] = useState(!extra_content); // si no hay extra, mostrar directamente

  // Simula resize tras carga del GIF
  const handleGifLoad = () => {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize")); // reposiciona Popover
      setShowContent(true); // ahora sí mostramos el contenido
    }, 50);
  };

  const getExtraContent = () => {
    if (!extra_content) return null;

    return React.cloneElement(extra_content, {
      style: { display: showContent ? "block" : "none" },
      onLoad: handleGifLoad,
    });
  };

  return (
    <Popover
      open={true}
      anchorReference="anchorPosition"
      anchorPosition={{
        // top: window.innerHeight / 2,
        top:
          align === "top"
            ? (window.innerHeight * 2) / 5
            : align === "bottom"
              ? (window.innerHeight * 3) / 5
              : window.innerHeight / 2,
        left:
          align === "left"
            ? (window.innerWidth * 2) / 5
            : align === "right"
              ? (window.innerWidth * 3) / 5
              : window.innerWidth / 2,
      }}
      anchorOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      TransitionComponent={Fade}
      transitionDuration={300}
      disableEnforceFocus
      disableAutoFocus
      PaperProps={{
        sx: {
          padding: "1rem",
          maxWidth: "min(90vw, 400px)",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          borderRadius: 2,
        },
      }}
      sx={{ zIndex: 1302 }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: 2,
          maxWidth: 400,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        {title && <Typography variant="h6">{title}</Typography>}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
          }}
        >
          {body && <Typography>{body}</Typography>}
          {currentStep === 0 && (
            <Box
              sx={{
                display: "flex",
                columnGap: "1rem",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <Box sx={{ whiteSpace: "nowrap" }}>{t("select_language")}:</Box>
              <LanguageSwitcher style={{ width: "fit-content" }} />
            </Box>
          )}
          {getExtraContent()}
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "1rem",
            justifyContent: "space-between",
          }}
        >
          {onSkip && !isLastStep ? (
            <Button variant="text" onClick={onSkip}>
              {t("skip")}
            </Button>
          ) : (
            <div />
          )}
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
            }}
          >
            {onPrevious && (
              <Button variant="outlined" onClick={onPrevious}>
                {t("previous")}
              </Button>
            )}
            {onNext && (
              <Button variant="contained" onClick={onNext}>
                {t(isLastStep ? "finish" : "next")}{" "}
                {!isLastStep && `${currentStep + 1}/${totalSteps}`}
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </Popover>
  );
}
